/**
 * מאזן root — owns everything under /Mazan (and /mazan).
 *
 *   anonymous  → landing page (public) and signup
 *   signed in  → the app Layout with "my reports", the wizard and the result page
 *
 * Like the portal tracks, the advisory onboarding chain (agreement →
 * questionnaire → risk approval) is opted OUT (requireClientOnboarding={false}):
 * a report buyer is not an advisory client.
 */

import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from '../../components/layout/Layout'
import PublicLayout from '../../components/layout/PublicLayout'
import ProtectedRoute from '../../components/auth/ProtectedRoute'
import TrackSignupPage from '../track/TrackSignupPage'
import MazanLandingPage from './MazanLandingPage'
import MazanMyReportsPage from './MazanMyReportsPage'
import MazanWizardPage from './MazanWizardPage'
import MazanResultPage from './MazanResultPage'
import { useAuthStore } from '../../store/authStore'
import { MAZAN } from '../../config/tracks'

const guard = (el: JSX.Element) => <ProtectedRoute requireClientOnboarding={false}>{el}</ProtectedRoute>

export default function MazanRoot() {
  const { isAuthenticated } = useAuthStore()

  return (
    <Routes>
      <Route element={<PublicLayout withFooter />}>
        <Route path="signup" element={<TrackSignupPage track={MAZAN.key} />} />
        {!isAuthenticated && <Route path="" element={<MazanLandingPage />} />}
      </Route>

      <Route element={<Layout />}>
        {isAuthenticated && <Route path="" element={<Navigate to="my" replace />} />}
        <Route path="my" element={guard(<MazanMyReportsPage />)} />
        <Route path="report/:id" element={guard(<MazanWizardPage />)} />
        <Route path="result/:id" element={guard(<MazanResultPage />)} />
      </Route>

      <Route path="*" element={<Navigate to="" replace />} />
    </Routes>
  )
}
